'use client';

import {
  FormCheckbox as AriakitFormCheckbox,
  VisuallyHidden,
  useFormContext,
  useStoreState,
} from '@ariakit/react';
import cx from 'classnames';

import { Icon } from '~/ui/components/icon';
import typographyStyles from '~/ui/styles/typography.module.scss';
import { invariant } from '~/utils/invariant';

import styles from './formCheckbox.module.scss';

export interface FormCheckboxProps {
  className?: string;
  name: string;
  label: string;
}

export function FormCheckbox({
  className,
  name,
  label,
  ...props
}: FormCheckboxProps): React.ReactElement {
  const form = useFormContext();
  invariant(form, 'FormCheckbox must be wrapped in FormProvider');

  const input = useStoreState(form, state => state.values[name]);

  return (
    <div className={cx(className, styles.checkbox)} {...props}>
      <label
        className={cx(styles.label, typographyStyles.bodySmall, {
          [styles.active]: !!input,
        })}
      >
        <VisuallyHidden>
          <AriakitFormCheckbox name={name} />
        </VisuallyHidden>
        <span className={styles.checkMark}>
          <Icon name="tick" className={styles.icon} />
        </span>

        {label}
      </label>
    </div>
  );
}
